import React from 'react';
import {
  Box,
  Container,
  Typography,
  Button,
  Divider
} from '@mui/material';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const handleLegalPageClick = (page) => {
    window.open(`/${page}`, '_blank');
  };

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: 'background.paper',
        borderTop: 1,
        borderColor: 'divider',
        mt: 'auto',
        py: 1.5
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ mb: 1.5 }}>
          <Typography variant="subtitle1" component="h5" sx={{ fontWeight: 'bold', color: 'primary.main' }}>
            Life Runbooks
          </Typography>
        </Box>
        
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'repeat(4, 1fr)' }, gap: 1, mb: 1 }}>
          {/* About Section */}
          <Box>
            <Typography variant="subtitle2" component="h6" sx={{ fontWeight: 'medium', mb: 0.5 }}>
              About
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Emergency procedures and step-by-step guides for life situations
            </Typography>
          </Box>

          {/* Legal Section */}
          <Box>
            <Typography variant="subtitle2" component="h6" sx={{ fontWeight: 'medium', mb: 0.5 }}>
              Legal
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
              <Button
                variant="text"
                size="small"
                onClick={() => handleLegalPageClick('privacy-policy')}
                sx={{ justifyContent: 'flex-start', p: 0, minWidth: 'auto', fontSize: '0.75rem' }}
              >
                Privacy Policy
              </Button>
              <Button
                variant="text"
                size="small"
                onClick={() => handleLegalPageClick('terms-of-service')}
                sx={{ justifyContent: 'flex-start', p: 0, minWidth: 'auto', fontSize: '0.75rem' }}
              >
                Terms of Service
              </Button>
              <Button
                variant="text"
                size="small"
                onClick={() => handleLegalPageClick('cookie-policy')}
                sx={{ justifyContent: 'flex-start', p: 0, minWidth: 'auto', fontSize: '0.75rem' }}
              >
                Cookie Policy
              </Button>
            </Box>
          </Box>

          {/* Support Section */}
          <Box>
            <Typography variant="subtitle2" component="h6" sx={{ fontWeight: 'medium', mb: 0.5 }}>
              Support
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Need help? Contact our support team for assistance.
            </Typography>
          </Box>

          {/* App Section */}
          <Box>
            <Typography variant="subtitle2" component="h6" sx={{ fontWeight: 'medium', mb: 0.5 }}>
              App
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Available on web and mobile devices.
            </Typography>
          </Box>
        </Box>

        <Divider sx={{ my: 1 }} />
        
        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="caption" color="text.secondary">
            © {currentYear} Life Runbooks. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;